import "./App.css";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import LoadingBackdrop from "../Components/LoadingBackdrop/LoadingBackdrop";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { colorBg, theme } from "../Resources/Design/theme";
import { HelmetProvider } from "react-helmet-async";
import baseRoutes from "./routes";
import { withRouter } from "../Resources/withRouter";
import ScrollUp from "../Components/ScrollUp";

function RouteControl({ ...props }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div
        className="App"
        style={{
          minWidth: "280px",
          position: "relative",
        }}
      >
        <ScrollUp />
        <header></header> {/* className="App-header" */}
        <main>
          <Outlet context={props} />
        </main>
        <footer></footer>
      </div>
    </ThemeProvider>
  );
}

const router = createBrowserRouter([
  {
    element: <RouteControl />,
    errorElement: <></>,
    children: baseRoutes,
  },
]);

function App() {
  return (
    <Suspense fallback={<LoadingBackdrop open={true} />}>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </Suspense>
  );
}

export default App;
